<template>
  <section class="quote-refer-info">
    <div class="box">
      <h2>Client Info</h2>
      <div class="table mg-b-10">
        <div class="tr">
          <span>Contract Period</span>
          <span>{{ getAllOptionName24('period', formData.contr_prd) }}</span>
        </div>
        <div class="tr">
          <span>Building Age </span>
          <span>{{ getAllOptionName24('bldg_ages', formData.bldg_age) }}</span>
        </div>
        <div class="tr">
          <span>Total Contract Sum </span>
          <span>{{ formData.tol_contr_sum }}</span>
        </div>
        <div class="tr">
          <span>Material Damage Coverage </span>
          <span>{{ getOptionName('yesNoOptions', formData.mat_dam_cvr_ind) }}</span>
        </div>
        <div class="tr">
          <span>Third Party Liability Coverage </span>
          <span>{{ getOptionName('yesNoOptions', formData.tp_lia_cvr_ind) }}</span>
        </div>
        <div class="tr">
          <span>Third Party Liability Limit</span>
          <span>{{ getAllOptionName24('limit_of_liability', formData.tppd_limit_amt) }}</span>
        </div>
        <div class="tr">
          <span>Outdoor Work or Scaffolding Work</span>
          <span>{{ getOptionName('yesNoOptions', formData.outdoor_wk_ind) }}</span>
        </div>
        <div class="tr">
          <span>Total Contract Value of Outdoor Work and/or Scaffolding Work</span>
          <span>{{ getAllOptionName24('scaffolding_wk', formData.scaffolding_wk) }}</span>
        </div>
        <div class="tr">
          <span>Employee Compensation</span>
          <span>{{ getOptionName('yesNoOptions', formData.employee_ind) }}</span>
        </div>
        <div class="tr">
          <span>Effective date</span>
          <span>{{ formData.pcy_cmnt_date }}</span>
        </div>
        <div class="tr">
          <span>Expiry date</span>
          <span>{{ formData.pcy_expry_date }}</span>
        </div>
      </div>
      <h3>Location of Works</h3>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span>{{ formData.work_addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span>{{ formData.work_addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span>{{ formData.work_addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span>{{ formData.work_addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span>{{ formData.work_addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span>{{ getAreaName('district', formData.work_addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span>{{ getAreaName('area', formData.work_addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span>{{ getAreaName('region', formData.work_addr_region) }}</span>
        </div>
        <div class="tr">
          <span>Property Type</span>
          <span>{{ getAllOptionName24('occupied_as', formData.occupied_as) }}</span>
        </div>
      </div>
    </div>

    <div class="box">
      <h2>Policyholder Detail</h2>
      <div class="table">
        <template v-if="formData.cust_typ == 1">
          <div class="tr">
            <span>Title</span>
            <span>{{ getOptionName('titleOptions', formData.isrd_title) }}</span>
          </div>
          <div class="tr">
            <span>Last Name</span>
            <span>{{ formData.isrd_lst_nm }}</span>
          </div>
          <div class="tr">
            <span>First Name</span>
            <span>{{ formData.isrd_fst_nm }}</span>
          </div>
          <div class="tr">
            <span>HKID</span>
            <span>{{ formData.id_no }}</span>
          </div>
          <div class="tr">
            <span>Mobile Number</span>
            <span>{{ formData.mobile_no }}</span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span>{{ formData.email }}</span>
          </div>
          <div class="tr">
            <span>Occupation</span>
            <span>{{ formData.occ }}</span>
          </div>
        </template>
        <template v-else>
          <div class="tr">
            <span>Company Name</span>
            <span>{{ formData.isrd_com_nm }}</span>
          </div>
          <div class="tr">
            <span>Business Registration Number</span>
            <span>{{ formData.id_no }}</span>
          </div>
          <!-- <div class="tr">
            <span>CI Number</span>
            <span>{{ formData.ci_no }}</span>
          </div> -->
          <div class="tr">
            <span>Company Phone No.</span>
            <span>{{ formData.phone_no }}</span>
          </div>
          <div class="tr">
            <span>Company Email</span>
            <span>{{ formData.email }}</span>
          </div>
          <div class="tr">
            <span>Nature of Business</span>
            <span>{{ getAllOptionName24('industry', formData.bsns_nature_id) }}</span>
          </div>
          <span class="title">Contact Person</span>
          <div class="tr">
            <span>Name</span>
            <span>{{ formData.contact_nm }}</span>
          </div>
          <div class="tr">
            <span>Occupation</span>
            <span>{{ getAllOptionName24('occupation', formData.contact_occ_id) }}</span>
          </div>
          <div class="tr">
            <span>Phone No.</span>
            <span>{{ formData.contact_phone }}</span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span>{{ formData.contact_email }}</span>
          </div>
        </template>
      </div>
    </div>
    <div class="box">
      <h3>Correspondence Address	</h3>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span>{{ formData.addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span>{{ formData.addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span>{{ formData.addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span>{{ formData.addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span>{{ formData.addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span>{{ getAreaName('district', formData.addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span>{{ getAreaName('area', formData.addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span>{{ getAreaName('region', formData.addr_region) }}</span>
        </div>
      </div>
    </div>

    <div class="box">
      <h2>Contractor</h2>
      <div class="table">
        <div class="tr">
          <span>Name</span>
          <span>{{ formData.con_nm }}</span>
        </div>
        <div class="tr">
          <span>Phone Number</span>
          <span>{{ formData.con_phone_no }}</span>
        </div>
      </div>
    </div>
    <div class="box">
      <h3>Correspondence Address</h3>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span>{{ formData.con_addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span>{{ formData.con_addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span>{{ formData.con_addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span>{{ formData.con_addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span>{{ formData.con_addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span>{{ getAreaName('district', formData.con_addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span>{{ getAreaName('area', formData.con_addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span>{{ getAreaName('region', formData.con_addr_region) }}</span>
        </div>
      </div>
      <div class="table">
        <div class="tr">
          <span>Sub Contractors (if any)</span>
          <span>{{ formData.sub_contractors }}</span>
        </div>
        <div class="tr">
          <span>Property Management Company (If any)</span>
          <span>{{ formData.property_management_company }}</span>
        </div>
      </div>
    </div>

    <!-- todo -->
    <div class="box">
      <h2>Upload Document</h2>
      <div class="table">
        <div class="tr">
          <span>Policyholder HKID</span>
          <span
            class="file"
            @click="openFile(formData.id_type_pic.url)">{{ formData.id_type_pic? 'file': '' }}</span>
        </div>
        <div class="tr">
          <span>Contract</span>
          <span
            class="file"
            @click="openFile(formData.contract.url)">{{ formData.contract? 'file': '' }}</span>
        </div>
        <!-- <div
          v-if="formData.cust_typ == 2"
          class="tr">
          <span>Certificate of Incorporation</span>
          <span
            class="file"
            @click="openFile(formData.cert_of_inc_pic.url)">{{ formData.cert_of_inc_pic? 'file': '' }}</span>
        </div> -->
        <div
          v-for="(item, index) in formData.other_file"
          :key="index"
          class="tr">
          <span>Additional Documents</span>
          <span
            class="file"
            @click="openFile(item.url)">{{ item.url? 'file': '' }}</span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'DecorationQuoteReferInfo',
  mixins: [MixinOptions],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {

  },
  methods: {
    openFile(url) {
      if(!url) return
      window.open(url, '_blank')
    },
  }
}
</script>
<style lang="scss" scoped>
.quote-refer-info {
  .box {
    margin-bottom: 15px;
  }
  .title {
    display: block;
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }
  .file {
    color: $blue;
    cursor: pointer;
  }
}
</style>
